import React from "react";
import { Tracker } from "../../../app/util/analytics";
import { getUser } from "../../../app/util/helpers";

export const DropdownTopbarItemToggler = React.forwardRef((props, ref) => {
  return (
    <div
      ref={ref}
      className="topbar-item"
      onClick={e => {
        e.preventDefault();
        props.onClick(e);
        Tracker.event(
          "Calling Mode",
          "Click",
          "Select Calling Mode",
          'Select Calling Mode Click',
          getUser()
        );
      }}
    >
      {props.children}
    </div>
  );
});

DropdownTopbarItemToggler.displayName = 'DropdownTopbarItemToggler';
